import React from "react";

const StatisticsSale = () => <h1>StatisticsSale</h1>;

export default StatisticsSale;
